import React from 'react';

export const MenuRootContext = React.createContext();